import classNames from 'classnames';
import React, { ChangeEvent, useRef, useState } from 'react';
import { Button } from 'src/common/button';
import LoadingSpinner from 'src/common/components/loading-spinner';
import { TextInput } from 'src/common/form/text-input';
import { Popover } from 'src/common/ui/popover';
import { functionNoop } from 'src/utils/function/noop';
import { apiGenerateDalleImageFromPrompt } from 'src/utils/journeyApi';
import { getImageMetrics } from '../helpers/get-image-metrics';
import { PlaceHolderIcon, toPlaceHolderLabel } from '../helpers/placeholders';
import { AspectRatio, BlockContent, BlockLayoutExtraParams, BlockPlaceholderType } from '../types';

type Props = {
  placeholderType: BlockPlaceholderType;
  loading: boolean;
  selected: boolean;
  onDelete: () => void;
};

export const PlaceholderBlock = ({ placeholderType, loading, selected, onDelete }: Props) => {
  return (
    <div
      tabIndex={0}
      onKeyUp={(e) => {
        if (e.key === 'Delete' || e.key === 'Backspace') {
          onDelete && onDelete();
        }
      }} 
      className={classNames('w-full h-full flex flex-1 items-center justify-center rounded-2xl transition', {
        'neue-block-selection-ring-selected bg-bedrock-light-gray': selected,
        'bg-bedrock-light-gray/50 hover:bg-bedrock-light-gray': !selected,
      })}
    >
      {loading ? <LoadingSpinner />:
        <Button
          size='regular'
          variant='tertiary'
          className='pointer-events-none'
          label={toPlaceHolderLabel(placeholderType)}
          icon={<PlaceHolderIcon className="w-4 h-4" blockPlaceholderType={placeholderType} />}
        />
      }
    </div>
  );
};